import script from "./Crearserviciocompleto.vue?vue&type=script&setup=true&lang=js"
export * from "./Crearserviciocompleto.vue?vue&type=script&setup=true&lang=js"

import "./Crearserviciocompleto.vue?vue&type=style&index=0&id=68349c00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68349c00"]])

export default __exports__